export enum TrackingListName {
    Recommendation = 'Recommendation',
    Bestseller = 'Bestseller',
    LastSeen = 'Last seen',
    Category = 'Category',
}
